import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, ReportIdSchema, ScanIdSchema } from "../primitives/ids.js";
import { PublicScanStatusKindSchema } from "./public-scan.js";
/** Studio project mode — external proof lanes vs default generation. */
export const StudioProjectModeV1Schema = z.enum([
    "DEFAULT_GENERATION",
    "EXISTING_SITE_SCAN",
    "EXTERNAL_PROOF_ONLY",
]);
export const ExternalEvidenceProvenanceV1Schema = z.enum(["SCANNED", "IMPORTED", "CONFIRMED"]);
export const ExternalEvidenceConfidenceV1Schema = z.enum(["HIGH", "MEDIUM", "LOW"]);
export const ExternalSiteSourceV1Schema = z
    .object({
    schemaId: z.literal("externalSite.source.v1"),
    url: z.string().url(),
    normalizedUrl: z.string().url(),
    attachedAt: z.string().datetime(),
    attachedBy: z.string().min(1).optional(),
})
    .strict();
export const ExternalScanCheckSummaryV1Schema = z
    .object({
    checkId: z.string().min(1),
    status: z.string().min(1),
    clientSafeSummary: z.string().min(1),
})
    .strict();
export const ExternalScanSnapshotV1Schema = z
    .object({
    schemaId: z.literal("externalScan.snapshot.v1"),
    snapshotId: z.string().min(1),
    scanId: ScanIdSchema,
    publicReportRef: ReportIdSchema,
    status: PublicScanStatusKindSchema,
    fetchTimestamp: z.string().datetime().optional(),
    htmlByteLength: z.number().int().min(0).optional(),
    checkSummary: z.array(ExternalScanCheckSummaryV1Schema).optional(),
    clientSafeSummaryRef: ReportIdSchema,
    provenance: ExternalEvidenceProvenanceV1Schema,
    confidence: ExternalEvidenceConfidenceV1Schema.optional(),
    unresolvedItems: z.array(z.string().min(1)).optional(),
})
    .strict();
export const ExternalSiteAttachRequestV1Schema = z
    .object({
    schemaId: z.literal("externalSite.attachRequest.v1"),
    url: z.string().min(1).max(2048),
})
    .strict();
export const ExternalSiteAttachResultV1Schema = z
    .object({
    schemaId: z.literal("externalSite.attachResult.v1"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    projectMode: StudioProjectModeV1Schema,
    source: ExternalSiteSourceV1Schema,
    snapshot: ExternalScanSnapshotV1Schema,
})
    .strict();
export const ExternalSiteProofViewV1Schema = z
    .object({
    schemaId: z.literal("externalSite.proofView.v1"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    projectMode: StudioProjectModeV1Schema,
    source: ExternalSiteSourceV1Schema.nullable(),
    latestSnapshot: ExternalScanSnapshotV1Schema.nullable(),
})
    .strict();
/** Agency-initiated scan — may create a project when projectId omitted (Studio V142 scan dock). */
export const AgencyExternalSiteScanRequestV1Schema = z
    .object({
    schemaId: z.literal("externalSite.agencyScanRequest.v1"),
    url: z.string().min(1).max(2048),
    projectId: ProjectIdSchema.optional(),
    projectMode: StudioProjectModeV1Schema.optional(),
    businessName: z.string().min(1).max(160).optional(),
})
    .strict();
export const AgencyExternalSiteScanResultV1Schema = z
    .object({
    schemaId: z.literal("externalSite.agencyScanResult.v1"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    projectMode: StudioProjectModeV1Schema,
    source: ExternalSiteSourceV1Schema,
    snapshot: ExternalScanSnapshotV1Schema,
})
    .strict();
/** Optional worker job context — links public scan job to project evidence snapshot. */
export const ExternalScanProjectContextV1Schema = z
    .object({
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    attachmentId: z.string().min(1),
    snapshotId: z.string().min(1),
})
    .strict();
//# sourceMappingURL=external-site-proof.js.map